
import React from 'react'
import { Dialog, DialogTitle, DialogContent, Grid, DialogActions, Button, Typography } from '@mui/material'
import StaticApproverDisplay from './StaticApproverDisplay'
import { useApproverSettings } from './useApproverSettings'
import { INITIAL_STATE } from './types'
import { ApproverSettings, UseApproverSettingsResult } from 'types'
import RenderSingleApproverSetting from './RenderSingleApproverSetting'
import { useGlobalApproverSettings } from '../../api/aws/approvers/fetchGlobalApprovers'
import { useSaveAllApprovers } from '../../api/aws/approvers/useSaveAllApprovers'

interface ApproverSettingsModalProps {
  open: boolean
  onClose: () => void
  settings: UseApproverSettingsResult
}
const labelMap: Record<string, string> = {
  creative: 'Creative',
  msa: 'MSA',
  seo: 'SEO & Launchpad',
  website: 'Website',
  housing: 'Housing / IO', // ✅ optional label
}
const ApproverSettingsModal: React.FC<ApproverSettingsModalProps> = ({ open, onClose }) => {
  const currentUser = JSON.parse(localStorage.getItem('currentUser'))
  const { data: globalApprovers, isLoading: _isLoading } = useGlobalApproverSettings(true)
  const settings: UseApproverSettingsResult = useApproverSettings(globalApprovers ?? INITIAL_STATE)
  const { mutate: saveAll, isPending } = useSaveAllApprovers()
  const { users, approvers: _approvers } = settings
  const finalApproverSettings = settings.approvers
  const hasChanges = JSON.stringify(finalApproverSettings) !== JSON.stringify(INITIAL_STATE)
  const handleSave = () => {
    const merged = settings.approvers
    console.log('merged', merged)
    saveAll({ data: merged as unknown as Record<string, string[]>, updatedBy: currentUser?.user_uuid || 'admin' }, { onSuccess: onClose })
  }

  // Save this to DB or update state globally

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>Approver Settings</DialogTitle>
      <DialogContent>
        <Grid container item spacing={2} alignItems='center'>
          <Grid item xs={6}>
            <Typography sx={{ textAlign: 'left', fontSize: 16, fontWeight: 'bold' }}>
              Current Approver Assignments
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ textAlign: 'left', fontSize: 16, fontWeight: 'bold' }}>
              Default Approver Reference
            </Typography>
          </Grid>
        </Grid>
        {['creative', 'msa', 'seo', 'website', 'housing'].map(type => (
          <Grid container item spacing={2} alignItems='center' key={type}>
            <Grid item xs={5}>
              <RenderSingleApproverSetting
                users={users}
                label={labelMap[type]}
                type={type as keyof ApproverSettings}
                selectedIds={settings.approvers[type as keyof ApproverSettings]}
                onAddApprover={settings.handleAddApprover}
              />
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={5}>
              <StaticApproverDisplay
                label={labelMap[type]}
                approverIds={INITIAL_STATE[type as keyof ApproverSettings]}
                users={users}
              />
            </Grid>
          </Grid>
        ))}
      </DialogContent>
      <DialogActions sx={{ pr: 4, pb: 3 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant='contained'
          // disabled={!hasChanges || isPending}
          onClick={handleSave}
          color='primary'
        >
          {isPending ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ApproverSettingsModal
